function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M26.18 9.099c-.572-1.374-1.729-2.858-2.637-3.327.74 1.45 1.167 2.904 1.33 3.99l.003.021c-1.486-3.704-4.006-5.198-6.064-8.45a13.882 13.882 0 01-.31-.504 3.83 3.83 0 01-.144-.274 2.397 2.397 0 01-.204-.541.035.035 0 00-.022-.012.047.047 0 00-.024 0 .025.025 0 00-.006.004c-.004 0-.007.003-.01.004l.005-.007c-3.301 1.934-4.421 5.511-4.524 7.301-1.32.09-2.58.576-3.62 1.394a3.889 3.889 0 00-.34-.257 6.092 6.092 0 01-.037-3.212c-1.35.615-2.4 1.586-3.163 2.445h-.006c-.522-.66-.485-2.837-.455-3.292-.006-.028-.389.199-.438.233-.46.328-.89.696-1.284 1.1-.45.456-.86.948-1.228 1.472A11.094 11.094 0 001.24 11.17l-.018.087c-.024.116-.114.695-.13.82v.03a12.53 12.53 0 00-.216 1.813v.067c0 7.258 5.884 13.143 13.143 13.143 6.5 0 11.897-4.72 12.954-10.919.022-.168.04-.337.06-.507.261-2.254-.029-4.623-.852-6.604zM11.03 19.387c.061.029.12.061.182.09l.009.005a8.648 8.648 0 01-.19-.095h-.001zm13.846-9.598v-.012.014-.002z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.18 9.099c-.571-1.374-1.729-2.858-2.637-3.327.74 1.45 1.167 2.904 1.33 3.99v.026c1.24 3.362.565 6.781-.409 8.87-1.506 3.232-5.152 6.545-10.86 6.384C7.444 24.867 2.012 20.289.997 14.298c-.184-.946 0-1.425.093-2.192-.113.59-.156.762-.212 1.813v.067c0 7.258 5.884 13.143 13.142 13.143 6.5 0 11.898-4.72 12.955-10.92.022-.167.04-.336.06-.506.26-2.254-.03-4.623-.854-6.604z",
  fill: "url(#paint1_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.18 9.099c-.571-1.374-1.729-2.858-2.637-3.327.74 1.45 1.167 2.904 1.33 3.99v.026c1.24 3.362.565 6.781-.409 8.87-1.506 3.232-5.152 6.545-10.86 6.384C7.444 24.867 2.012 20.289.997 14.298c-.184-.946 0-1.425.093-2.192-.113.59-.156.762-.212 1.813v.067c0 7.258 5.884 13.143 13.142 13.143 6.5 0 11.898-4.72 12.955-10.92.022-.167.04-.336.06-.506.26-2.254-.03-4.623-.854-6.604z",
  fill: "url(#paint2_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.792 10.643c.03.02.055.04.082.06a7.138 7.138 0 00-1.22-1.592c-4.085-4.085-1.071-8.858-.563-9.1l.006-.008c-3.302 1.934-4.422 5.511-4.525 7.301.153-.01.306-.024.462-.024 2.463 0 4.61 1.356 5.758 3.363z",
  fill: "url(#paint3_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.042 11.46c-.021.327-1.176 1.454-1.58 1.454-3.738 0-4.344 2.26-4.344 2.26.164 1.905 1.49 3.473 3.096 4.302.073.038.147.072.218.106.129.055.258.11.387.158.55.194 1.126.305 1.71.328 6.55.307 7.82-7.832 3.092-10.196 1.21-.21 2.467.277 3.169.77-1.149-2.008-3.295-3.363-5.759-3.363-.156 0-.308.013-.461.023a6.577 6.577 0 00-3.617 1.396c.2.17.427.396.904.866.893.881 3.18 1.788 3.185 1.895z",
  fill: "url(#paint4_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.042 11.46c-.021.327-1.176 1.454-1.58 1.454-3.738 0-4.344 2.26-4.344 2.26.164 1.905 1.49 3.473 3.096 4.302.073.038.147.072.218.106.129.055.258.11.387.158.55.194 1.126.305 1.71.328 6.55.307 7.82-7.832 3.092-10.196 1.21-.21 2.467.277 3.169.77-1.149-2.008-3.295-3.363-5.759-3.363-.156 0-.308.013-.461.023a6.577 6.577 0 00-3.617 1.396c.2.17.427.396.904.866.893.881 3.18 1.788 3.185 1.895z",
  fill: "url(#paint5_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.342 8.261c.107.069.194.127.274.18a6.092 6.092 0 01-.037-3.212c-1.35.615-2.4 1.586-3.164 2.445.062-.002 1.968-.036 2.927.587z",
  fill: "url(#paint6_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.996 14.298C2.011 20.29 7.443 24.867 13.61 25.042c5.708.161 9.351-3.152 10.86-6.384.973-2.09 1.65-5.508.409-8.87v-.025c0 .003 0 .008.003.022.465 3.044-1.083 5.993-3.503 7.988a.316.316 0 00-.007.017c-4.717 3.84-9.23 2.317-10.144 1.695a7.7 7.7 0 01-.191-.095c-2.75-1.312-3.886-3.82-3.643-5.969-2.321 0-3.113-1.958-3.113-1.958s2.084-1.487 4.832-.194c2.544 1.198 4.934.194 4.934.194-.005-.107-2.292-1.017-3.183-1.896-.477-.47-.703-.696-.904-.866a3.889 3.889 0 00-.34-.257c-.078-.054-.164-.109-.274-.18-.958-.623-2.865-.589-2.928-.587h-.006c-.52-.66-.484-2.837-.455-3.292-.006-.028-.388.199-.437.233-.46.329-.89.697-1.285 1.1-.449.456-.86.949-1.227 1.472a11.094 11.094 0 00-1.764 3.983c-.01.025-.477 2.066-.247 3.125z",
  fill: "url(#paint7_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.654 9.112c.48.47.89 1.006 1.22 1.592.069.051.135.106.197.164 2.98 2.743 1.421 6.627 1.302 6.905 2.42-1.994 3.97-4.943 3.503-7.988-1.486-3.706-4.006-5.2-6.064-8.453a14.023 14.023 0 01-.31-.503 3.79 3.79 0 01-.144-.274 2.387 2.387 0 01-.204-.541.034.034 0 00-.022-.012.047.047 0 00-.024 0 .027.027 0 00-.006.004c-.004 0-.007.003-.01.004-.509.243-3.523 5.016.562 9.102z",
  fill: "url(#paint8_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.07 10.865a2.525 2.525 0 00-.197-.164l-.082-.06c-.701-.493-1.958-.98-3.168-.77 4.727 2.364 3.458 10.503-3.093 10.196a5.84 5.84 0 01-1.71-.328 7.206 7.206 0 01-.386-.158 3.81 3.81 0 01-.219-.106l.01.006c.913.623 5.426 2.147 10.143-1.696l.007-.017c.117-.274 1.676-4.157-1.305-6.903z",
  fill: "url(#paint9_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.118 15.175s.606-2.261 4.344-2.261c.404 0 1.559-1.128 1.58-1.455.021-.327-2.39 1.004-4.934-.193-2.748-1.293-4.833.193-4.833.193s.792 1.96 3.114 1.96c-.244 2.148.892 4.653 3.642 5.968.062.029.12.06.183.09-1.605-.829-2.93-2.398-3.096-4.302z",
  fill: "url(#paint10_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.18 9.099c-.572-1.374-1.729-2.858-2.637-3.327.74 1.45 1.167 2.904 1.33 3.99l.003.021c-1.486-3.704-4.006-5.198-6.064-8.45a13.882 13.882 0 01-.31-.504 3.83 3.83 0 01-.144-.274 2.397 2.397 0 01-.204-.541.035.035 0 00-.022-.012.047.047 0 00-.024 0 .025.025 0 00-.006.004c-.004 0-.007.003-.01.004l.005-.007c-3.301 1.934-4.421 5.511-4.524 7.301.153-.01.306-.023.461-.023 2.464 0 4.61 1.355 5.759 3.362-.702-.492-1.958-.98-3.168-.77 4.727 2.365 3.457 10.504-3.093 10.197a5.847 5.847 0 01-1.71-.328 7.206 7.206 0 01-.386-.158 3.911 3.911 0 01-.219-.106l.009.006a8.268 8.268 0 01-.191-.096c.061.03.12.062.182.09-1.608-.83-2.933-2.399-3.1-4.303 0 0 .607-2.261 4.345-2.261.404 0 1.559-1.128 1.58-1.455-.005-.106-2.292-1.016-3.184-1.895-.476-.47-.703-.696-.903-.866a3.89 3.89 0 00-.34-.257 6.092 6.092 0 01-.037-3.212c-1.35.615-2.4 1.586-3.164 2.445h-.006c-.52-.66-.484-2.837-.455-3.292-.006-.028-.388.199-.437.233-.46.328-.89.696-1.285 1.1-.45.456-.86.948-1.227 1.472A11.094 11.094 0 001.24 11.17l-.017.087a21.46 21.46 0 00-.152.829c0 .01 0-.01 0 0-.102.607-.168 1.22-.196 1.834v.067c0 7.258 5.884 13.143 13.143 13.143 6.5 0 11.897-4.72 12.954-10.919.022-.168.04-.337.06-.507.261-2.254-.029-4.623-.852-6.604zm-1.304.675v.014-.014z",
  fill: "url(#paint11_linear)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.431 3.011) scale(27.399)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".13",
  stopColor: "#FFBD4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".19",
  stopColor: "#FFAC31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".25",
  stopColor: "#FF9D17"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".28",
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#FF563B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".47",
  stopColor: "#FF3750"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".71",
  stopColor: "#F5156C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".78",
  stopColor: "#EB0878"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".86",
  stopColor: "#E50080"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.42 14.212) scale(27.399)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".3",
  stopColor: "#960E18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#B11927",
  stopOpacity: ".74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".43",
  stopColor: "#DB293D",
  stopOpacity: ".34"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#F5334B",
  stopOpacity: ".09"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#FF3750",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.723 -3.207) scale(19.8494)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".13",
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".25",
  stopColor: "#FFDC3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#FF9D12"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.39 21.37) scale(13.0457)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".35",
  stopColor: "#3A8EE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".47",
  stopColor: "#5C79F0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#9059FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C139E6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(-13.897 51.854 -51.193) scale(6.91169 8.11958)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".21",
  stopColor: "#9059FF",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".28",
  stopColor: "#8C4FF3",
  stopOpacity: ".06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".75",
  stopColor: "#7716A8",
  stopOpacity: ".45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".97",
  stopColor: "#6E008B",
  stopOpacity: ".6"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.073 1.89) scale(9.38547)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE226"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".12",
  stopColor: "#FFDB27"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".3",
  stopColor: "#FFC82A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#FFA930"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".73",
  stopColor: "#FF7E37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".79",
  stopColor: "#FF7139"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.45 -4.063) scale(40.0427)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".11",
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".46",
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".62",
  stopColor: "#FF5634"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".72",
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".9",
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(2.93328 29.03943 -19.07901 1.92718 16.58 .312)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".06",
  stopColor: "#FFE847"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".17",
  stopColor: "#FFC830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".3",
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".36",
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".45",
  stopColor: "#FF672A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".57",
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".74",
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.853 5.366) scale(24.9987)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".14",
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".48",
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".59",
  stopColor: "#FF5634"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".66",
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".9",
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.452 6.83) scale(27.3612)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".09",
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".23",
  stopColor: "#FFE141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".51",
  stopColor: "#FFAF1E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".63",
  stopColor: "#FF980E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: "24.44",
  y1: "4.203",
  x2: "2.622",
  y2: "25.253",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".05",
  stopColor: "#FFF44F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".11",
  stopColor: "#FFE847"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".22",
  stopColor: "#FFC830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".37",
  stopColor: "#FF980E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#FF8B16"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".46",
  stopColor: "#FF672A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".53",
  stopColor: "#FF3647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".7",
  stopColor: "#E31587"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: "24.177",
  y1: "4.09",
  x2: "5.613",
  y2: "22.655",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: ".17",
  stopColor: "#FFF44F",
  stopOpacity: ".8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".27",
  stopColor: "#FFF44F",
  stopOpacity: ".63"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".49",
  stopColor: "#FFF44F",
  stopOpacity: ".22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".6",
  stopColor: "#FFF44F",
  stopOpacity: "0"
}))));